/*
 *
 * Package: `@dbh/nothing`.
 *
 */const Nothing=()=>null;Nothing.displayName="Nothing";

export { Nothing as default };
